var file_upload_viewer_default = {
  "fontElementMap": "dpAa0",
  "file_upload_container": "dA00s",
  "file_upload_link": "u1M8-",
  "file_upload_error_container": "-VLzB",
  "file_upload_file_info": "l2ZXR",
  "file_upload_type_icon": "cn0BD",
  "file_upload_status_icon_container": "pHNHZ",
  "file_upload_status_icon": "Yvtm9",
  "file_upload_description": "ra4HL",
  "file_upload_name_container": "ZdTz3",
  "file_upload_name": "slPfa",
  "file_upload_extension": "Ct6ud",
  "file_loader_icon": "sNCJK",
  "file_upload_icon_frame": "Wy--7",
  "file_upload_icon_background": "G-q1R"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
